import { Component, OnInit } from '@angular/core';
import { PackagingUnitExpenseResultsDto } from 'src/app/data-transfer/entities/evaluation-entities/expense-result-dto';
import { PackagingUnitDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-dto';
import { ExpenseCalculationParentComponent } from '../expense-calculation-parent/expense-calculation-parent.component';
import { ActivatedRoute } from '@angular/router';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { DisplayType } from '../expense-calculation-html-template/expense-calculation-html-template.component';

@Component({
  selector: 'app-expense-calculation-packaging-unit',
  templateUrl: './expense-calculation-packaging-unit.component.html',
  styleUrls: ['./expense-calculation-packaging-unit.component.scss']
})
export class ExpenseCalculationPackagingUnitComponent extends ExpenseCalculationParentComponent implements OnInit {
  expenseResults!: PackagingUnitExpenseResultsDto[];
  packagingUnit!: PackagingUnitDto;

  DisplayType = DisplayType;

  constructor(private route: ActivatedRoute) { super(); }

  ngOnInit(): void {
    this.routeDataSubscription = this.route.data.subscribe(data => {
      const packagingUnit = data.packagingUnit;

      this.expenseResults = data.expenseResults[0];
      this.packagingUnit = packagingUnit;
      this.packagingPartType = PackagingPart.Unit;
      this.licenseFeeCountries = data.licenseFeeCountries;
      this.ecomodulationCountries = data.ecomodulationCountries;
      this.plasticTaxCountries = data.plasticTaxCountries;
    });
  }
}
